import { createTheme } from "@mui/material";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../_const/color.const";

export const theme = createTheme({
    typography: {
        // fontFamily: 'Roboto'
        fontFamily: 'Sans-Serif'
    },
    palette: {
        primary: {
            main: PRIMARY_COLOR[0],
        },
        secondary: {
            main: SECONDARY_COLOR
        }
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    //boxShadow: 'none'
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                elevation1: {
                    //boxShadow: 'none'
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    //boxShadow: 'none'
                },
            },
        },
    }
});